import { Component, Input,Output, EventEmitter } from '@angular/core';
import { Notification } from '../../../../../interfaces/core/notification.entity';

@Component({
	selector: 'app-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
	@Input() notification!: Notification;
	@Output() closeEvent: EventEmitter<string> = new EventEmitter();

	showNotification: boolean = true;

	constructor() { }

	markAsRead(){
		this.closeEvent.emit(this.notification.id);
	}
}
